import { isECatalogue } from '~/utils';

const init = async (): Promise<void> => {
  const isInShoppingPage = window.location.pathname.split('/').includes('shopping');
  if (isInShoppingPage) {
    return;
  }

  const ROOT_ELEMENT_ID = 'mini-shopping-bag-root';
  const rootElement = document.getElementById(ROOT_ELEMENT_ID);

  if (!rootElement) {
    throw new Error(`Element #${ROOT_ELEMENT_ID} was not found!`);
  }

  const appRender = await import(/* webpackChunkName: "app" */ './AppRender');
  appRender.render(rootElement, isECatalogue());
};

init().catch((error) => {
  throw error;
});
